export const actionTypes = {
  REQUEST_START: 'TAPS.SNU.REQUEST_START',
  REQUEST_START_SKIP_LOADING: 'TAPS.SNU.REQUEST_START.SKIP_LOADING',
  REQUEST_SUCCESS: 'TAPS.SNU.REQUEST_SUCCESS',
  REQUEST_FAILURE: 'TAPS.SNU.REQUEST_FAILURE',
};

export function startRequest() {
  return {
    type: actionTypes.REQUEST_START,
  };
}

export function startRequestSkipLoading() {
  return {
    type: actionTypes.REQUEST_START_SKIP_LOADING,
  };
}

export function requestSuccess(data) {
  return {
    type: actionTypes.REQUEST_SUCCESS,
    payload: data,
  };
}

export function requestFailure(error) {
  return {
    type: actionTypes.REQUEST_FAILURE,
    payload: error,
  };
}
